import React from 'react';
import './App.css';
import JokeList from './JokeList';

function App() {
  return (
    <div className="App">
      <JokeList />
    </div>
  );
}

export default App;
